import { create } from "zustand";
import { Vessel } from "@/lib/types";
import { devtools } from "zustand/middleware";

type VesselStore = {
  selectedVessel: Vessel | null;
  setSelectedVessel: (vessel: Vessel) => void;
};

const useVessel = create<VesselStore>()(
  devtools(
    (set) => ({
      selectedVessel: null,
      setSelectedVessel: (vessel: Vessel) => set({ selectedVessel: vessel }),
    }),
    { name: "vessel" }
  )
);

export default useVessel;
